import React, { Component } from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import "../css/post.css"
import {
  FacebookShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  WeiboShareButton,
  PocketShareButton,
  InstapaperShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  PocketIcon,
  InstapaperIcon,
  WeiboIcon,
} from "react-share";


class Video extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();

    this.state = {
      data: this.props.pageContext.node
    }
  }

  render() {

    var shareUrl = this.props.location.href;
    var title = this.state.data.title;
    var post = this.state.data.content
    var featured_img = this.state.data.featured_media.source_url
    var video_id = this.state.data.excerpt.replace(/<p>|<\/p>/gi, "")

    return (
      <Layout>
        <div className="mainContainer deep-blue">
          <div className="centeredContainer blogPost">
            <h1 style={{flexBasis: "100%"}}>{title}</h1>
            <iframe
              className="post-video"
              src={`https://www.youtube.com/embed/${video_id}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen>
            </iframe>
          </div>
        </div>
        <div className="mainContainer" style={{paddingTop: 150}}>
          <div className="centeredContainer post-content wrap" style={{padding: "0 50px"}}>
            <div className="post-social">
              <FacebookShareButton
                url={shareUrl}
                quote={title}
                className="Demo__some-network__share-button"
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
                  <TwitterShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button">
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <RedditShareButton
                url={shareUrl}
                title={title}
                windowWidth={660}
                windowHeight={460}
                className="Demo__some-network__share-button"
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <TumblrShareButton
                url={shareUrl}
                title={title}
                className="Demo__some-network__share-button"
              >
                <TumblrIcon size={32} round />
              </TumblrShareButton>
              <EmailShareButton
                url={shareUrl}
                subject={title}
                body="body"
                className="Demo__some-network__share-button"
              >
                <EmailIcon size={32} round />
              </EmailShareButton>
            </div>
            <div dangerouslySetInnerHTML={{__html:post }}/>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Video
